interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  active: string;
  onChange: (id: string) => void;
}

/**
 * docs/DESIGN_SYSTEM.md §4.7 — underline style, not pill/segmented, for
 * consistency with the sidebar's own active-state treatment.
 */
export function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div className="flex gap-6 border-b border-border-subtle" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          onClick={() => onChange(tab.id)}
          className={[
            'pb-3 -mb-px text-body-medium border-b-2 transition-colors min-h-[44px]',
            active === tab.id
              ? 'border-accent-management-500 text-text-primary'
              : 'border-transparent text-text-secondary hover:text-text-primary',
          ].join(' ')}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
